import { inject } from 'vue';

import type { AuthContext } from '@shared/context/authContext';
import { authInjectionKey } from '@shared/context/injectionKeys';

export const useAuthContext = (): AuthContext => {
  const auth = inject(authInjectionKey);

  if (!auth) {
    throw new Error('Auth context is not provided');
  }

  return auth;
};
